<template>
  <div>
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Search Options
          </div>
        </template>
      </es-header>
    </div>
    <div class="tabs-container no-border-top no-bottom-border">
      <es-tabs :tabs="availableOptions" ref="tabs"></es-tabs>
    </div>
  </div>
</template>

<script>
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';
import EsTabs from '@/components/EsTabs.vue';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsHeader,
    EsTabs,
  },
  data() {
    return {
      searchOptions: [],
    };
  },
  created() {
    this.searchOptions = [
      {
        isAvailable: this.hasModule('PRSID:SRCH:OPTIONS:PRSN:SRCH'),
        name: 'PidSearchPerson',
        label: 'BY PERSON',
      },
      {
        isAvailable: this.hasModule('PRSID:SRCH:OPTIONS:PRSN:SRCH'),
        name: 'PidSearchId',
        label: 'BY ID',
      },
      {
        isAvailable: this.hasModule('PRSID:SRCH:OPTIONS:LOC:SRCH'),
        name: 'PidSearchLocation',
        label: 'BY LOCATION',
      },
      {
        isAvailable: this.hasModule('PRSID:SRCH:OPTIONS:BATCH:SRCH'),
        name: 'PidSearchFile',
        label: 'BY FILE',
      },
      {
        isAvailable: this.hasModule('PRSID:SRCH:OPTIONS:ADV:SRCH'),
        name: 'PidSearchAdvanced',
        label: 'ADVANCED',
      },
    ];
  },
  computed: {
    availableOptions() {
      return this.searchOptions.filter(opt => opt.isAvailable);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
